import { Component, Input, OnInit, OnDestroy, OnChanges } from '@angular/core';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import { DataTableSource } from '../../../classes/DataTableSource/datatablesource';

import { StudentTestInfo, StudentTestInfoSubject, StudentTestInfoYear } from '../../../services/application/application.service';

@Component({
    selector: 'test-history',
    styleUrls: ['testhistory.component.css'],
    templateUrl: 'testhistory.component.html',
})
export class TestHistoryComponent implements OnInit, OnDestroy, OnChanges {
    AnyMeeting = false;
    AnyOutdated = false;
    @Input() History: StudentTestInfo[];
    // HistoryData: DataTableSource<StudentTestInfo>;
    UIHistory: UIStudentTestInfo[];

    constructor() {
        // this.HistoryData = new DataTableSource<StudentTestInfo>(this.History);
    }

    ngOnDestroy() {}

    ngOnInit() {}

    ngOnChanges() {
        // Update the data being sourced.
        // this.HistoryData.Update(this.History);
        let anyMeet = false;
        let anyOut = false;

        const hist = (this.History || []).map((h) => {
            return {
                TestDescription: h.TestDescription,
                // RowSpan: (h.Years || []).reduce((p, c) => p + ((c.Subjects && c.Subjects.length) || 1), 0),
                Years: (h.Years || []).map((yr) => {
                    return {
                        GradeLevel: yr.GradeLevel,
                        SchoolYear: yr.SchoolYear,
                        // RowSpan: (yr.Subjects && yr.Subjects.length) || 1,
                        // RowSpan: (yr.Subjects || []).reduce((p, c) => p + ((c.Exams && c.Exams.length) || 1), 0),
                        Subjects: (yr.Subjects || []).map((sub) => {
                            if (!anyMeet && (sub.Exams || []).some((x) => x.PastThreshold)) anyMeet = true;
                            if (!anyOut && (sub.Exams || []).some((x) => x.Outdated)) anyOut = true;

                            return {
                                Description: sub.Description,
                                // RowSpan: (sub.Exams && sub.Exams.length) || 1,
                                Exams: sub.Exams,
                            };
                        }),
                    };
                }),
            } as UIStudentTestInfo;
        });

        // Parse through and build out the rowspans needed.
        hist.forEach((h) => {
            h.Years.forEach((yr) => {
                yr.Subjects.forEach((sub) => {
                    sub.RowSpan = sub.Exams.length || 1;
                });

                yr.RowSpan = yr.Subjects.map((s) => s.RowSpan).reduce((p, c) => p + c);
            });

            h.RowSpan = h.Years.map((y) => y.RowSpan).reduce((p, c) => p + c);
        });

        this.UIHistory = hist;
        this.AnyMeeting = anyMeet;
        this.AnyOutdated = anyOut;
    }
}

// #region Custom Classes

interface UIStudentTestInfo extends StudentTestInfo {
    RowSpan: number;
    Years: UIStudentTestInfoYear[];
}

interface UIStudentTestInfoSubject extends StudentTestInfoSubject {
    RowSpan: number;
}

interface UIStudentTestInfoYear extends StudentTestInfoYear {
    RowSpan: number;
    Subjects: UIStudentTestInfoSubject[];
}

// #endregion



// WEBPACK FOOTER //
// ./src/app/ui/testhistory/testhistory.component.ts